<template>
    <div>
        <CRow>
            <CCol sm="12">
                <CCard>
                    <CCardHeader>
                        <strong>تعیین وضعیت</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CForm @keyup.enter="validator();submit()">
                            <CRow>
                                <CCol sm="3">
                                    <CSelect v-model="form.state.val" label="وضعیت فایل"
                                        :options="[
                                            {value: '1', label: 'مورد قبول'},
                                            {value: '2', label: 'رد شده'},
                                            {value: '4', label: 'بررسی شده'},
                                        ]"
                                        placeholder="انتخاب کنید"
                                        :description="form.state.inv"
                                        @change="form.state.val=$event.target.value" />
                                </CCol>
                                <CCol sm="3">
                                    <CTextarea v-model="form.message.val" :description="form.message.inv" label="توضیحات" rows="3"
                                        @keyup.enter="access=false" />
                                </CCol>
                            </CRow>
                        </CForm>
                        <br>
                        <div class="form-group form-actions">
                            <CButton @click="validator();submit()" color="primary">ارسال</CButton>
                        </div>
                    </CCardBody>
                </CCard>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import validator from '../mixins'
export default {
    mixins: { validator },
    components: { ModelSelect },
    data() {
        return {
            form: {
                state: { val: '', inv: '', v: { req: true, max: 4 } },
                message: { val: '', inv: '', v: { req: true, max: 512 } },
            },
            disable: false,
            access: true,
        }
    },
    methods: {
        submit(){
            if(this.access){
                if(this.disable == false){
                    const data = new FormData();
                    for (const key in this.form){
                        data.set(key, this.form[key].val); 
                    }
                    data.set('id', this.$route.params.id);
                    this.axios.put('user_files/', data)
                        .then(() => {
                            this.$notify({
                                group: 'foo',
                                type: 'success',
                                text: 'ارسال با موفقیت انجام شد.'
                            });
                            for (const key in this.form){
                                this.form[key].val = '';
                            }
                        })
                        .catch(() => {
                            this.$notify({
                                group: 'foo',
                                type: 'error',
                                text: 'خطا! لطفا مجددا تلاش کنید.'
                            });
                        })
                }
            }
            this.access = true;
        },
    },
    beforeCreate() {
        if (this.$store.state.perms.can_accept_user_files == false
            && this.$store.state.perms.can_accept_user_files_for_same_group_user == false
            && this.$store.state.perms.can_accept_user_files_for_all_users == false
            && this.$store.state.verif == false) {
            this.$router.push('/403')
        }
    },
}
</script>
